

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-bml-signature.route', ['squid', 'xo-bml-signature.directive']).factory('$BmlSignatureRoute', function ($ComponentRoute) {
        return $ComponentRoute.extend('BmlSignatureRoute', {

            name: 'bmlsignature',
            trackingData: {
                fptiState: 'ppc_signature'
            },
            titleContent: 'consumerCreditInfo.applicationApprovedMessage',
            directive: 'xo-bml-signature-page',

            children: []

        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js
 ** module id = 471
 ** module chunks = 1
 **/